const MoneyToNumber = (money) => {
  const mutated = parseInt(money.replace(/[^\w\s]/gi, '')) / 100;

  return mutated;
};

export default MoneyToNumber;
